<template>
  <va-edit-layout>
    <model-form :id="id" :title="title" :item="item"></model-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"]
};
</script>
